import React from "react";
import Banner from "../components/Banner";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Intro from "../components/Intro";
import Projects from "../components/Projects";
import Skills from "../components/Skills";

const Homepage = () => {
  return (
    <div className="w-full">
      <Banner />
      <Intro />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

export default Homepage;
